import store from '../index'; // eslint-disable-line import/no-cycle
const { VUE_APP_GATEKEEPER_URL: gatekeeperUrl } = process.env;

export default {
  needsToChooseKeyboard: ({ device: { isMobile, usingExternalKeyboard } = {} }) =>
    isMobile && usingExternalKeyboard === undefined,
  ipadWithoutExternalKeyboard: ({ device: { isMobile, usingExternalKeyboard } = {} }) =>
    isMobile && !usingExternalKeyboard,
  usingExternalKeyboard: ({ device: { isMobile, usingExternalKeyboard } = {} }) =>
    isMobile && usingExternalKeyboard,
  logoutUrl() {
    const {
      student: { sessionId }
    } = store.get();
    return `${gatekeeperUrl}/logout/keyboarding?session=${sessionId}`;
  }
};
